import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = ({ schoolInfo }) => {
  const [allBlogs, setAllBlogs] = useState([]);
  useEffect(() => {
    axios.get("JSON/news&events.json").then((response) => {
      setAllBlogs(response.data[0].blogs.reverse());
    });
  }, []);
  return (
    <>
      <footer className="eschool-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-xl-3 col-md-6 col-12">
              <div className="eschool-footer-about">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={schoolInfo?.school_Footer_Logo} alt="#" />
                  </Link>
                </div>
                <div className="footer-about">
                  <h5 className="footer-about-title">
                    {schoolInfo?.footer_title}
                  </h5>
                  <p className="footer-about-text">
                    {schoolInfo?.footer_detail}
                  </p>
                  <span className="footer-about-copyright">
                    Copyright © 2022{" "}
                    <a
                      href="https://edufy.cloud"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Edufy.{" "}
                    </a>{" "}
                    All Rights Reserved. <br />
                    Powered by{" "}
                    <a
                      href="https://getup.com.bd"
                      target="_blank"
                      rel="noreferrer"
                    >
                      GetUp
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-2 col-md-6 col-12">
              <div className="eschool-footer-widget footer-resources">
                <h4 className="eschool-f-widget-title">Resourses</h4>
                <ul className="eschool-f-widget-list">
                  <li>
                    <Link to="#">Online admission</Link>
                  </li>
                  <li>
                    <Link to="#">Notice board</Link>
                  </li>
                  <li>
                    <Link to="#">About us</Link>
                  </li>
                  <li>
                    <Link to="#">Admission info</Link>
                  </li>
                  <li>
                    <Link to="#">Class routin</Link>
                  </li>
                  <li>
                    <Link to="#">Result history</Link>
                  </li>
                  <li>
                    <Link to="#">Student results</Link>
                  </li>
                  <li>
                    <Link to="#">The blog/events</Link>
                  </li>
                  <li>
                    <Link to="#">Contact us</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-xl-4 col-md-6 col-12">
              <div className="eschool-footer-widget footer-news">
                <h4 className="eschool-f-widget-title">News/Events</h4>
                <div className="eschool-footer-news">
                  {allBlogs?.slice(0, 3)?.map((singleBlog) => (
                    <Link to="#" className="eschool-f-news-single">
                      <div className="eschool-f-news-img">
                        <img src={singleBlog?.img} alt="#" />
                      </div>
                      <div className="eschool-f-news-content">
                        <h6 className="eschool-f-news-cont-title">
                          {singleBlog?.title}
                        </h6>
                        <Link to="#" className="eschool-f-news-cont-btn">
                          Read more
                        </Link>
                      </div>
                    </Link>
                  ))}

                  <div className="eschool-f-news-bottom">
                    <Link to="/blog" className="eschool-btn">
                      More blogs<i className="fi fi-rs-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-3 col-md-6 col-12">
              <div className="eschool-footer-widget footer-contact">
                <h4 className="eschool-f-widget-title">Contacts</h4>
                <div className="f-widget-contact-list">
                  <div className="f-widget-contact-single">
                    <h5 className="f-widget-contact-title">
                      <i className="fi fi-rs-marker"></i>Our adress
                    </h5>
                    <p className="f-widget-contact-text">
                      {schoolInfo?.address}
                    </p>
                  </div>
                  <div className="f-widget-contact-single">
                    <h5 className="f-widget-contact-title">
                      <i className="fi fi-rr-phone-call"></i>Hotline
                    </h5>
                    <ul className="f-widget-contact-list">
                      <li>
                        <a href={`tel:${schoolInfo?.hot_number_1}`}>
                          {schoolInfo?.hot_number_1}
                        </a>
                      </li>
                      <li>
                        <a href={`tel:${schoolInfo?.hot_number_2}`}>
                          {schoolInfo?.hot_number_2}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="f-widget-contact-single">
                    <h5 className="f-widget-contact-title">
                      <i className="fi fi-rr-envelope-open"></i>Email
                    </h5>
                    <ul className="f-widget-contact-list">
                      <li>
                        <a href={`mailto:${schoolInfo?.email_1}`}>
                          {schoolInfo?.email_1}
                        </a>
                      </li>
                      <li>
                        <a href={`mailto:${schoolInfo?.email_2}`}>
                          {schoolInfo?.email_2}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="f-widget-contact-single">
                    <ul className="f-widget-contact-social-list">
                      <li>Follow us:</li>
                      <li>
                        <a
                          href={schoolInfo?.facebook_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="icofont-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={schoolInfo?.skype_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="icofont-skype"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={schoolInfo?.instagram_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="icofont-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={schoolInfo?.whatsapp_link}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="icofont-whatsapp"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
